import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.itineraries')
  .factory('$itinerariesPageable', itinerariesPageableObjectFactory);

/* @ngInject */
function itinerariesPageableObjectFactory($bringozFactory: $bringozFactory,
                                          ItinerariesPageableAPI: BringozApi,
                                          Itineraries_Pageable_DS: DataStoreConfig) {

  function $itinerariesPageable(id: string) {
    return $bringozFactory(id, ItinerariesPageableAPI, Itineraries_Pageable_DS);
  }

  return $itinerariesPageable;
}
